<template>
  <div id="app">
    <MainHeader
      ref="MainHeader"
      :menuStatus="menuStatus"
      @set-menu-status="menuStatus = $event"
      @open-shop-cart="shopCartDrawerStatus = true"
      @open-search-dialog="searchDialogStatus = true"
    />
    <MainMenu
      :menuStatus="menuStatus"
      @set-menu-status="menuStatus = $event"
      :style="{ paddingTop: `${pagePaddingTop}px` }"
    />
    <ShopCartDrawer
      ref="ShopCartDrawer"
      :shopCartDrawerStatus="shopCartDrawerStatus"
      @close-action="shopCartDrawerStatus = false"
    />
    <SearchDialog
      ref="SearchDialog"
      :dialog="searchDialogStatus"
      @close-search-dialog="searchDialogStatus = false"
    />
    <MainDialog ref="MainDialog" />
    <div id="MainPageContainer" :style="{ paddingTop: `${pagePaddingTop}px` }">
      <router-view
        :imageLoaded="imageLoaded"
        :shopCartDrawerStatus="shopCartDrawerStatus"
        @load-image="LoadImage"
        @set-meta="SetMetaData"
      />
    </div>

    <ContactFooter />
    <MainFooter />
    <MainLoading />
    <CookieConsentDialog />
  </div>
</template>

<style src="@/assets/css/output.css"></style>

<script>
import { GetMetaData } from "@/tools/meta";
import { delLocalStorage } from "@/tools/localStorage";
import { CheckFontLoad } from "@/tools/loadFont";
import Lenis from "@studio-freight/lenis";
import imagesloaded from "imagesloaded";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import MainHeader from "@/components/MainHeader.vue";
import MainDialog from "@/components/MainDialog.vue";
import ContactFooter from "@/components/ContactFooter.vue";
import MainFooter from "@/components/MainFooter.vue";
import MainMenu from "@/components/MainMenu.vue";
import MainLoading from "@/components/MainLoading.vue";
import ShopCartDrawer from "@/components/ShopCartDrawer.vue";
import SearchDialog from "@/components/SearchDialog.vue";
import CookieConsentDialog from "@/components/CookieConsentDialog.vue";
export default {
  name: "App",
  components: {
    MainHeader,
    ContactFooter,
    MainFooter,
    MainMenu,
    MainLoading,
    ShopCartDrawer,
    SearchDialog,
    MainDialog,
    CookieConsentDialog,
  },
  data() {
    return {
      menuStatus: false,
      shopCartDrawerStatus: false,
      imageLoaded: false,
      metaData: null,
      pagePaddingTop: 0,
      lenis: null,
      searchDialogStatus: false,
    };
  },
  methods: {
    LoadImage() {
      if (this.$route.meta.animation) {
        // document.querySelector("body").style.overflowY = "hidden";
        this.$store.commit("setLoadingCount", 1);
      }
      this.imageLoaded = false;
      const images = gsap.utils.toArray("img");
      imagesloaded(images).on("always", () => {
        this.LoadFinish();
      });
    },
    async LoadFinish() {
      //設定讀取完成
      if (this.$route.meta.animation) {
        // document.querySelector("body").style.overflowY = "auto";
        this.$store.commit("setLoadingCount", -2);
      }
      this.imageLoaded = true;
      console.log("所有圖片都已加載完成");

      setTimeout(() => {
        ScrollTrigger.refresh();
      }, 150);

      this.$nextTick(() => {
        this.SetPagePaddingTop();
        CheckFontLoad();
      });
    },
    SetMetaData({ title, content = "", image = "" }) {
      this.metaData = GetMetaData(title, content, image);
    },
    SetPagePaddingTop() {
      if (this.$refs.MainHeader) {
        let disableTopSpaceList = ["home"];
        if (disableTopSpaceList.includes(this.$route.name)) {
          this.pagePaddingTop = this.$refs.MainHeader.$el.clientHeight;
        } else if (window.innerWidth < 768) {
          this.pagePaddingTop = this.$refs.MainHeader.$el.clientHeight + 20;
        } else {
          this.pagePaddingTop = this.$refs.MainHeader.$el.clientHeight + 40;
        }
      }
    },
    InitShopCart() {
      this.$store.dispatch("shopCartModule/GetShopCart");
    },
    RemoveTmpData() {
      if (this.$route.name != "結帳" && this.$route.name != "訂單完成") {
        delLocalStorage("check_out_form");
        delLocalStorage("trade_data");
        delLocalStorage("trade_shopcart");
        delLocalStorage("trade_checkout_data");
      }
    },
    InitSmoothScroll() {
      this.lenis = new Lenis();
      this.lenis.on("scroll", ScrollTrigger.update);

      gsap.ticker.add((time) => {
        this.lenis.raf(time * 1000);
      });

      gsap.ticker.lagSmoothing(0);
    },
  },
  computed: {
    dataLoadStatus() {
      return this.$store.getters.allDataLoaded;
    },
    announcementData() {
      let list = [];
      for (let i = 1; i <= 10; i++) {
        const currentData = this.$store.getters.columnData(
          `event_announcement_${i}`
        );
        if (currentData && currentData != "") {
          list.push(currentData);
        }
      }
      return list;
    },
  },
  watch: {
    $route() {
      this.imageLoaded = false;
      this.$nextTick(() => {
        this.SetPagePaddingTop();
        this.lenis.scrollTo(0);
      });
    },
    dataLoadStatus() {
      if (this.dataLoadStatus) {
        console.log("資料讀取完成");
        this.InitShopCart();
        this.RemoveTmpData();
        this.$store.commit("setLoadingCount", -1);
        this.$nextTick(() => {
          this.SetPagePaddingTop();
          CheckFontLoad();
        });
      }
    },
  },
  mounted() {
    this.SetPagePaddingTop();
    window.addEventListener("resize", () => {
      this.SetPagePaddingTop();
    });
  },
  created() {
    this.InitSmoothScroll();
    if (!this.dataLoadStatus) {
      console.log("沒有資料，撈取資料");
      this.$store.commit("setLoadingCount", 2);
      this.$store.dispatch("getAllData");
    }
  },
  metaInfo() {
    return this.metaData;
  },
};
</script>
